import { Platform, StyleSheet } from 'react-native';

export const fieldInputReset = StyleSheet.create({
  input: {
    flex: 1,
    minWidth: 0,
    padding: 0,
    ...Platform.select({ web: { outlineStyle: 'none' as const }, android: { includeFontPadding: false } }),
  },
});
